module.exports = __webpack_public_path__ + "img/CertificateOfHonor04.9f8f3a81.png";